export default __webpack_public_path__ + "static/media/Logo_henri-side.0410354c.svg";